function isMac(): boolean {
  return navigator && navigator.platform && navigator.platform.toLowerCase().indexOf("mac") >= 0;
}

export const PlatformUtil = {
  isMac,
};
